import { styled } from "@mui/material/styles"
import Stack from "@mui/material/Stack"
import { useTranslation } from "react-i18next"
import { kebabToCamelCase } from "utils/stringUtils"
import { formatRelativeDate } from "utils/dateUtils"
import { feedTitleIconMap } from "components/organisms/FeedCard/utils"

type FeedCardTitleProps = {
  type: FeedType;
  date: string;
}

export default function FeedCardTitle(props: FeedCardTitleProps) {
  const { type, date } = props

  const { t } = useTranslation()

  return (
    <Container>
      {feedTitleIconMap[type]}
      <p>{t(`feed.${kebabToCamelCase(type)}`)}</p>
      <span>{formatRelativeDate(date)}</span>
    </Container>
  )
}

const Container = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  gap: "4px",
  alignItems: "center",
  marginBottom: "12px",

  "& p": {
    fontSize: "1.3rem",
    fontWeight: 700,
    color: theme.palette.gray["16"]
  },

  "& span": {
    fontSize: "0.9rem",
    fontWeight: 400,
    color: theme.palette.gray["12"],
    fontFamily: "VazirmatnFD, serif !important",
    marginLeft: "4px"
  }
}))

